import React from 'react'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react';
import moment from 'moment';

import "./InvoiceForDriver.css"




const InvoiceForDriver = ({server}) => {
    const {token} = useParams()
    const [data, setData] = useState(null)
    const [totalPrice, setTotalPrice] = useState(0)

    const stampLink =  "api2/img/razitko-1.png"
    
    const generateQrCodeUrl = (iban, price, vs) => {
        return `https://abcnet.cz:10050/qr/SPD*1.0*ACC:${iban}*AM:${price}*CC:CZK*X-VS:${vs}*MSG:QR%20platba`;
      };

    const format = (date) => {
        return moment(date).format('DD.MM.YYYY')
    }
    const QrCode = ({ iban, price, vs }) => {

        if (!iban || !price || !vs) {
        return <p>Prosím, zadejte všechny potřebné údaje.</p>;
        }
    
        const qrCodeUrl = generateQrCodeUrl(iban, price, vs);
    
        return <img src={qrCodeUrl} alt="QR platba" id="qrcode"/>;
    };

    
    useEffect( () => {

        // Získá aktuální data z API
        fetch(server + '/api2/InvoiceController.php', {
        method: 'POST',
        body: JSON.stringify({action: 'SHOW' , token})
        })
        .then((resp) => resp.json())
        .then( (response) => { 

            if(response.status === 'OK'){
                setData(response.payload)
                let totalPriceTemp = 0
                // Spočítá celkovou cenu
                response.payload.items.forEach( one => {
                    console.log(one.price)
                    totalPriceTemp += parseInt(one.price)
                })
                setTotalPrice(totalPriceTemp)
            }
            
            
        })
    },[])
    
    if(!data){
        return <p>faktura nenalzena</p>
    }
    
    return (
        <section className='App loading'>
       
            <div className='page4Invoice'>
                <section className='page4header'>
                    <div className="headerTittle">
                        <h4>{data.company.contact}</h4>
                    </div>
                
                    <h1 style={{color: 'white'}}>FAKTURA</h1>
    
                    <div className="numberAndDate">
                        <h4>Daňový doklad číslo: {data.invoice.id}</h4>
                        <h4>Datum: {format(data.invoice.created_date)}</h4>
                    </div>
                </section>
    
                <section className="adres">
                    <div className="adresLeft">
    
                        <div className="colum dodavatel">
                            <h4>Dodavatel</h4>
                            <p>{data.company.contact}</p>
                            <p>Ič: {data.company.ic} </p>
                        </div>
    
                        <div className="colum odberatel">
                            <h4>Odběratel</h4>
                            <h3>{data.driver ? data.driver.contact: data?.invoice.clientName}</h3>
                            <h3>{data.driver ? data.driver.address :data?.invoice.clientAddress}</h3>
                            <p>Ič: {data.driver ? data.driver.ic : data?.invoice.clientIc} </p>
                        </div>
    
                    </div>
    
                    <div className="adresRight">
                    
                        <div>
                            <h4>Příjemce</h4>
                            <h3>{data.driver ? data.driver.contact: data?.invoice.clientName}</h3>
                            <h3>{data.driver ? data.driver.address :data?.invoice.clientAddress}</h3>
                        </div>
    
                    </div>
                </section>
                {
                    data.invoice.payedBy === 'card' &&
                        <>
                        <section className='infoOfPayment'>
                            <h3>Celková cena: {totalPrice} Kč</h3>
                            <h3>{data.company.bank_account}</h3>
                            <h3>VS: {data.invoice.id}</h3>
                        </section>
            
                        <section className='payDate'>
                            <h2>Převodem zaplatit do: {format(data.invoice.dateTillPay)}</h2>
                        </section>
                    </>
                }

                {
                    data.invoice.payedBy &&
                        <>
                        <section className='payDate'>
                            <h2>{data.invoice.payedBy === 'cache' && `Zaplaceno hotově , již neplaťte. Celková cena: ${totalPrice} Kč`}</h2>
                        </section>
                    </>
                }
              
    
                <section className='itemsOfInvoice'>
                {
                    data && data.items.map( (one) => {
                            return (
                                <div className='oneLineOfContent' key={one.id}>
                                    <p id="ks">{one.quantity}</p>
                                    <p id="text">{one.item}</p>  
                                    <p id="price">{one.price} Kč</p>
                                </div>
                                )
                        })
                    }
    
                </section>
    
                <section className='footer'>
                    <QrCode iban={data.company.iban} price={totalPrice} vs={data.invoice.id}/>
                    <img src={stampLink} style={{width: 250, height: 150}}/>
                </section>
            </div> 
        </section>
      )
  
}

export default InvoiceForDriver
